import CaseCategoryComponent from "../../Components/Masters/CaseCategory/CaseCategoryComponent"

const CaseCategoryPage = () =>{
    return(
        <CaseCategoryComponent/>
    )
}

export default CaseCategoryPage